import { Link } from "react-router-dom";

const facts = [
  ["Based in", "Pokhara, Nepal"],
  ["Experience", "3+ years"],
  ["Focus", "Web scraping, backend APIs, data pipelines"],
  ["Works with", "Python, Node.js, Scrapy, Playwright, PostgreSQL"],
  ["Clients", "Nepal and worldwide, remote"],
];

const expertise = [
  {
    title: "Scraping & crawling",
    tools: "Scrapy, Playwright, Puppeteer, Cheerio, Selenium",
  },
  { title: "Backend", tools: "Python, Node.js, Express.js, REST API design" },
  { title: "Data & storage", tools: "PostgreSQL, MongoDB, MySQL, automated ETL" },
  {
    title: "Automation",
    tools: "Cron jobs, proxy rotation, anti-bot handling",
  },
];

const explore = [
  {
    to: "/about",
    label: "01",
    title: "Read my story",
    text: "How I got into scraping and how I work.",
  },
  {
    to: "/skills",
    label: "02",
    title: "Full skill list",
    text: "Languages, scraping tools and databases I use.",
  },
  {
    to: "/certificate",
    label: "03",
    title: "Certificates",
    text: "Courses and credentials I have completed.",
  },
];

const About = () => {
  return (
    <section className="py-20 lg:py-24 bg-dark-900/40 text-light-100 border-t border-dark-600">
      <div className="container mx-auto px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
          <div>
            <p className="font-code text-sm text-primary-400 mb-3">About</p>
            <h2 className="text-3xl md:text-4xl font-bold mb-8">
              I turn messy websites into clean, usable data.
            </h2>

            <div className="space-y-5 text-gray-300 text-lg">
              <p>
                I started out curious about how data moves across the web, and
                that turned into a specialty: automated pipelines that collect,
                clean and structure data from sites that don't offer an API.
              </p>
              <p>
                I build scrapers for eCommerce price monitoring, SERP tracking,
                lead generation and competitor analysis, designed to cope with
                anti-bot measures, JavaScript-rendered pages and large crawls.
              </p>
              <p>
                I also build the backend around the scraper (REST APIs, PostgreSQL,
                MongoDB and MySQL, scheduling) so the data ends up somewhere you can
                actually use it.
              </p>
            </div>
          </div>

          <div className="space-y-6">
            <dl className="glass-card divide-y divide-dark-600">
              {facts.map(([label, value]) => (
                <div
                  key={label}
                  className="grid grid-cols-3 gap-4 px-6 py-4 text-sm"
                >
                  <dt className="font-code text-gray-500">{label}</dt>
                  <dd className="col-span-2 text-light-100">{value}</dd>
                </div>
              ))}
            </dl>

            <div className="grid gap-4 sm:grid-cols-2">
              {expertise.map((item) => (
                <div key={item.title} className="glass-card p-5">
                  <h3 className="font-semibold mb-2 text-primary-400">
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-400">{item.tools}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <ul className="mt-14 grid gap-4 md:grid-cols-3">
          {explore.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                className="group flex h-full items-center justify-between gap-4 rounded-lg border border-dark-600 bg-dark-800 p-6 transition-colors hover:border-primary-500/60 hover:bg-dark-700"
              >
                <div>
                  <span className="font-code text-xs text-amber-400">
                    {item.label}
                  </span>
                  <h3 className="mt-2 text-lg font-semibold">{item.title}</h3>
                  <p className="mt-1 text-sm text-gray-400">{item.text}</p>
                </div>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-dark-500 text-primary-400 transition-all group-hover:border-primary-400 group-hover:bg-primary-500 group-hover:text-dark-900">
                  <svg
                    className="h-4 w-4 transition-transform group-hover:translate-x-0.5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5 12h14m-6-6 6 6-6 6"
                    />
                  </svg>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default About;
